'use strict';

var UserManagementRoleManagementController = function UserManagementRoleManagementController($scope, dataRetrieverService, userManagementConstants, userManagementCommonCustomRenderers, userManagementSelectedRole, $q) {
  $scope.customRenderers = userManagementCommonCustomRenderers;
  $scope.gridId = 'user-management-role-management';
  $scope.mode = 'user-management-role-management-mode';
  var DEFAULT_ROLE = 'Default';
  var roleManagementRetriever = dataRetrieverService.getDataRetriever('USER_MANAGEMENT_SCREEN', $scope.mode);
  roleManagementRetriever.setCustomSearchCriteriaRules($q.reject());
  $scope.retrieveData = function () {
    roleManagementRetriever.setCustomSearchCriteriaRules([]);
    $scope.$broadcast('grid:loadData:' + $scope.gridId);
  };
  $scope.newRolePanel = {
    visible: false,
    editable: false,
    role: null
  };
  $scope.defaultRolePanel = {
    visible: false
  };
  function newRolePanelVisible() {
    $scope.newRolePanel.visible = true;
    $scope.roleManagementState = userManagementConstants.MANAGE_ROLES_SCREENS.EDIT_ROLE;
  }
  $scope.$on('user-management-manage-users:change-screen', function onChangeScreen(event, value) {
    $scope.roleManagementState = value;
  });
  function defaultRolePanelVisible() {
    $scope.defaultRolePanel.visible = true;
    $scope.roleManagementState = userManagementConstants.MANAGE_ROLES_SCREENS.VIEW_DEFAULT_ROLE;
  }
  $scope.addNewRole = function () {
    $scope.newRolePanel.role = null;
    $scope.newRolePanel.editable = false;
    newRolePanelVisible();
  };
  $scope.editRole = function (ev, roleData) {
    userManagementSelectedRole.selectedRole(roleData.entityData);
    if (roleData.entityData.role !== DEFAULT_ROLE) {
      $scope.newRolePanel.editable = true;
      $scope.newRolePanel.role = roleData.entityData.role;
      newRolePanelVisible();
    } else {
      defaultRolePanelVisible();
    }
  };
  $scope.retrieveData();
};
UserManagementRoleManagementController.$inject = ['$scope', 'DataRetrieverService', 'UserManagementConstants', 'UserManagementCommonCustomRenderers', 'UserManagementSelectedRoleService', '$q'];
module.exports = UserManagementRoleManagementController;